import { Box, Divider, Pagination, Stack } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import ProjectDataItem from "./ProjectDataItem";

function updateSearchParams(setSearchParams, params = {}) {
    setSearchParams((prev) => {
        Object.entries(params).forEach(([key, value]) => prev.set(key, value));
        return prev;
    });
}

function ProjectDataTable(props) {
    const { dataResult = {}, sx } = props;
    const lastPage = dataResult.data?.meta?.last_page ?? 0;
    const currentPage = dataResult.data?.meta?.current_page ?? 1;
    const [searchParams, setSearchParams] = useSearchParams();
    const handleOnChangePage = (event, page) => updateSearchParams(setSearchParams, { page: page });

    const LoadingData = <>loading...</>;
    const NoData = <>no data</>;
    let DataRow = NoData;

    if (dataResult.isFetching) {
        DataRow = LoadingData;
    }

    if (dataResult.data?.data?.length > 0) {
        DataRow = dataResult.data?.data?.map((x, index) => <ProjectDataItem key={index} project={x} />);
    }

    return (
        <Box sx={{ ...sx }}>
            <Stack divider={<Divider />}>{DataRow}</Stack>

            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: 3,
                }}
            >
                <Pagination
                    showFirstButton
                    showLastButton
                    count={lastPage}
                    page={currentPage}
                    onChange={handleOnChangePage}
                />
            </Box>
        </Box>
    );
}

export default ProjectDataTable;
